import classNames from 'classnames';
import { useState, useEffect, useRef, useMemo } from 'react';
import styles from './FJCoverVideo.module.less';
import useIsInViewport from '../../../hooks/useIsInViewPort';
import PropTypes from 'prop-types';
import FJImage from '../FJImage/FJImage';
import useTabActive from '../../../hooks/useTabActive';
import FJVideoUtil from '../../../util/FJVideoUtil';
const FJCoverVideo = props => {
    const {
        coverImage,
        videoSrc,
        coverVideo,
        boxClassName,
        videoClassName,
        children,
        onClick,
        autoPlay = false,
        delayPlayTime = 1000,
        addRefreshEvent = false,
    } = props;
    const _videoRef = useRef(null);
    const [isMouseEnter, setIsMouseEnter] = useState(false);
    const [_containerRef, isVisible] = useIsInViewport({ threshold: 0.8 });
    const [showVideo, setShowVideo] = useState(false);
    const isTabActive = useTabActive();

    useEffect(() => {
        if (!autoPlay) return;
        let timer = null;
        if (isVisible && isTabActive) {
            timer = setTimeout(() => {
                setShowVideo(true);
                clearTimeout(timer);
            }, delayPlayTime);
        } else {
            FJVideoUtil.releaseVideo(_videoRef.current);

            setShowVideo(false);
            timer && clearTimeout(timer);
        }
        return () => {
            FJVideoUtil.releaseVideo(_videoRef.current);

            timer && clearTimeout(timer);
        };
    }, [isVisible, isTabActive]);

    const _onClick = e => {
        onClick && onClick(e);
    };

    const _onMouseEnter = () => {
        if (autoPlay) return;
        setIsMouseEnter(true);
    };
    const _onMouseLeave = () => {
        if (autoPlay) return;
        setIsMouseEnter(false);
    };
    const isShowVideo = useMemo(() => {
        if (autoPlay) {
            return showVideo;
        }
        return isMouseEnter;
    }, [isMouseEnter, showVideo, autoPlay]);
    return (
        <div
            className={classNames(boxClassName, styles.box)}
            onClick={_onClick}
            onMouseEnter={_onMouseEnter}
            onMouseLeave={_onMouseLeave}
            ref={_containerRef}
        >
            <FJImage
                imgSrc={coverImage}
                imgClassName={classNames(styles.image, videoClassName)}
                isShowLoading={true}
                reloadStyle={{
                    backgroundColor: '#FFF',
                }}
                addRefreshEvent={addRefreshEvent}
            />
            {isShowVideo && (
                <video
                    className={classNames(styles.video, videoClassName)}
                    poster={coverImage}
                    muted={true}
                    loop={true}
                    ref={_videoRef}
                    loading='lazy'
                    autoPlay={true}
                    preload='none'
                >
                    {coverVideo && <source src={coverVideo} type='video/mp4' />}
                    <source src={videoSrc} type='video/mp4' />
                </video>
            )}
            {children}
        </div>
    );
};
FJCoverVideo.propTypes = {
    videoSrc: PropTypes.string.isRequired,
    coverVideo: PropTypes.string,
    boxClassName: PropTypes.string,
    videoClassName: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
    onClick: PropTypes.func,
    onRefresh: PropTypes.func,
    autoPlay: PropTypes.bool,
    coverImage: PropTypes.string,
    delayPlayTime: PropTypes.number,
    addRefreshEvent: PropTypes.bool,
};
export default FJCoverVideo;
